module.exports = __webpack_public_path__ + "img/FATIMA NECKLACE LIME.957621a.svg";